import { Box } from '@montugroup/design-system';

export function CustomerLocationMarker() {
  return (
    <Box
      sx={(theme) => ({
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: theme.palette.info.main,
        border: '2px solid white',
        boxShadow: '0 0 2px rgba(0,0,0,0.25)',
        cursor: 'auto',
      })}
    />
  );
}

export default CustomerLocationMarker;
